import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 6,
        projectName: 'Pokemon Lite Game',
        projectDesc: 'Pokemon Lite is a mini games that i make by using react Js, the role play is the user need to catch the pokemon with 50% success percentange, and user also can change their pokemon name which is they already catch, and player also able to see their inventory',
        tags: ['React Js' ,'Bootstrap', 'css', 'redux', 'Javascript', 'firebase'],
        code: 'https://github.com/RizkyPratamaHidayat/Pokemon-lite',
        demo: 'https://tokopedia-test-rizkyph.web.app/',
        image: "  https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/Capture9.PNG?alt=media&token=3d152c08-ac56-4c42-8f5c-4e2720efbadb",
    },
    {
        id: 1,
        projectName: 'EASI Mobile Apps',
        projectDesc: "this project i created a marketplace base on mobile apps for android and ios by using react native, for the bussiness flow is almost familiar like others marketplace, but there's something unique in this project which is have biding feature that seller and customer can do the transactions live (real time)",
        tags: ['React Native' ,'styleSheet', 'redux', 'Javascript', 'express.js', 'mysql', 'firebase'],
        code: '#',
        demo: '#',
        image: 'https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/Capture%202.PNG?alt=media&token=164a49bb-de36-4e5f-86fa-57c131a96e8d',
    },
    {
        id: 2,
        projectName: 'EASI Web Apps',
        projectDesc: "this project i created a marketplace base on Web apps  by using react Js, for the bussiness flow is almost familiar like others marketplace, but there's something unique in this project which is have biding feature that seller and customer can do the transactions live (real time)",
        tags: ['React Js' ,'Bootstrap', 'css', 'redux', 'Javascript', 'express.js', 'mysql', 'firebase'],
        code: '#',
        demo: '#',
        image: "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/Capture.PNG?alt=media&token=0b6dfec6-144f-41e4-980d-e0b822d0f267"
    },
    {
        id: 3,
        projectName: 'MIFX Mobile App',
        projectDesc: 'this project is developing trading apps base on mobile apps (android & Ios) for one of broker company in jakarta by using react native.',
        tags: ['React Native' ,'styleSheet', 'redux', 'Javascript', 'firebase Analityc'],
        code: '#',
        demo: '#',
        image:"https://cdn-5fe60d74c1ac1810089cce8a.closte.com/wp-content/uploads/2021/03/mifx-logo.jpg"
    },
   
    {
        id: 4,
        projectName: 'Kotakin Client side',
        projectDesc: 'this project is create web app system for one of store in my city medan, this web apps have a purpose where make the customer can order the stuff online without need to come to the physical store ',
        tags: ['React Js' ,'Bootstrap', 'css', 'redux', 'Javascript', 'express.js', 'mysql', 'firebase'],
        code: '#',
        demo: '#',
        image: "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/Capture4.PNG?alt=media&token=dd079aeb-9b83-4ca7-b0c1-34bf22d15e75"
    },
    {
        id: 5,
        projectName: 'Kotakin Backoffice side',
        projectDesc: 'this project is the backoffice side of the kotakin client side that will manage the product, transactions, even procurement',
        tags: ['React Js' ,'Bootstrap', 'css', 'redux', 'Javascript', 'express.js', 'mysql', 'firebase'],
        code: '#',
        demo: '#',
        image: "https://firebasestorage.googleapis.com/v0/b/kotakin-client.appspot.com/o/Capture7.PNG?alt=media&token=7b299f54-a467-4b6a-b193-e5aa5b1aff8a",
    },
  
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/